<template>
  <div class="engagement-steps-picker" data-qid="engagement-steps-picker">
    <div v-for="(phase, index) in phases" :key="'picker-' + phase" class="engagement-steps-picker__phase">
      <div class="engagement-steps-picker__phase-title">
        {{ index + 1 }}. {{ $t('projects.engagement.phase.' + phase) }}
      </div>
      <b-form-checkbox v-for="step in steps[phase]"
                       :key="'picker-step-' + step"
                       :checked="value.includes(step)"
                       :disabled="disabled"
                       @change="toggle(step, $event)"
                       :data-qid="'engagement-steps-picker-' + step"
      >
        {{ $t('projects.engagement.step.' + step) }}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { PHASE_KEYS, PHASES, ALWAYS_INCLUDED_PHASES, allSteps } from '@/views/Projects/Engagement/engagement.js';

// Checkbox list of the engagement steps that can be left out, grouped by phase; v-model is the list of included step keys.
// Execution and reporting are always included, so they aren't listed.
export default {
  name: 'EngagementStepsPicker',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      phases: PHASE_KEYS.filter(phase => !ALWAYS_INCLUDED_PHASES.includes(phase)),
      steps: PHASES
    }
  },
  methods: {
    toggle(step, checked) {
      const selected = checked ? this.value.concat([step]) : this.value.filter(item => item !== step);
      // Keep template order
      this.$emit('input', allSteps().filter(item => selected.includes(item)));
    }
  }
}
</script>
